import { formatValueDateToMoment } from '../../../components/helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export type EnrichedDate = {
  date: values.v1.Date;
  isCurrentMonth: boolean;
  isAvailable: boolean;
  isSelectedDate: boolean;
  isSelectedWeek: boolean;
};

export const generateEnrichedDates = (
  dates: values.v1.Date[],
  highlightedDates: values.v1.Date[],
  selectedDate: values.v1.Date | undefined,
  startDate: values.v1.Date
): EnrichedDate[] => {
  const startMoment = formatValueDateToMoment(startDate);
  const selectedMoment = selectedDate
    ? formatValueDateToMoment(selectedDate)
    : null;
  const highlightedDateMoments = highlightedDates.map(formatValueDateToMoment);

  return dates.map((date) => {
    const dateMoment = formatValueDateToMoment(date);

    const isCurrentMonth = dateMoment.month() === startMoment.month();
    const isSelectedDate = dateMoment.isSame(selectedMoment);
    const isSelectedWeek = dateMoment.isSame(selectedMoment, 'week');
    const isAvailable = highlightedDateMoments.some((highlightedMoment) =>
      dateMoment.isSame(highlightedMoment)
    );

    return {
      date,
      isCurrentMonth,
      isAvailable,
      isSelectedDate,
      isSelectedWeek,
    };
  });
};
